import { ChangeDetectionStrategy, Component, inject, OnInit, input } from '@angular/core'
import { Store } from '@ngrx/store'
import { closeMetricDetailModal } from '@features/metric-detail/store/actions/metric-detail.actions'
import { TranslateService, TranslatePipe } from '@ngx-translate/core'
import { MetricRequest } from '@core/models/metric.models'
import {
  selectMetricDetailItems,
  selectMetricDetailLoader,
  selectMetricDetailSubHeader
} from '@features/metric-detail/store/selectors/metric-detail.selectors'
import { CallingContext } from '@features/seasons/models/seasons.models'
import { Observable } from 'rxjs'
import { MetricDetailSubHeader } from '@features/metric-detail/models/metric-detail.models'
import { MetricDetailHeaderComponent } from './components/metric-detail-header/metric-detail-header.component'
import { MetricDetailSubHeaderComponent } from './components/metric-detail-sub-header/metric-detail-sub-header.component'
import { LoaderComponent } from '@shared/components/loader/loader.component'
import { MetricItemModule } from '@mediacoach/ui'
import { MetricDetailItemComponent } from './components/metric-detail-item/metric-detail-item.component'
import { AsyncPipe } from '@angular/common'
import { IonContent } from '@ionic/angular/standalone'

@Component({
  selector: 'mcm-metric-detail-container',
  templateUrl: './metric-detail-container.component.html',
  styleUrls: ['./metric-detail-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MetricDetailHeaderComponent,
    MetricDetailSubHeaderComponent,
    LoaderComponent,
    MetricItemModule,
    MetricDetailItemComponent,
    TranslatePipe,
    AsyncPipe,
    IonContent
  ]
})
export class MetricDetailContainerComponent implements OnInit {
  private readonly _store: Store = inject(Store)
  private readonly _translate: TranslateService = inject(TranslateService)

  readonly items$ = this._store.select(selectMetricDetailItems)
  readonly loading$ = this._store.select(selectMetricDetailLoader)

  subHeader$!: Observable<MetricDetailSubHeader>

  readonly callingContext = input.required<CallingContext>()

  metricToDetailed: MetricRequest

  get currentLang() {
    return this._translate.currentLang
  }

  ngOnInit(): void {
    this.subHeader$ = this._store.select(selectMetricDetailSubHeader(this.callingContext()))
  }

  close() {
    this._store.dispatch(closeMetricDetailModal())
  }
}
